'use client';

import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import { useSolutionStore } from '../../store/solution';

const SelectedFilters = () => {
  const filters = useSolutionStore((s) => s.filters);

  const removeChip = (name: string) => {
    const newFilters = filters.filter((filter) => filter.name !== name);
    useSolutionStore.setState({ filters: newFilters });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        margin: '0.5rem 1rem 0 1rem',
        borderRadius: '5px',
        fontSize: '1em',
        fontWeight: 'bold',
        textAlign: 'center',
        flexWrap: 'wrap',
        gap: '0.3rem',
      }}
    >
      {filters.map((filter, index) => (
        <Chip
          key={filter.name}
          label={filter.name}
          color="primary"
          onDelete={() => removeChip(filter.name)}
          sx={{
            fontSize: '0.8em',
            fontWeight: 'bold',
            ...(index === 0 && { ml: 0 }),
          }}
        />
      ))}
    </Box>
  );
};

export default SelectedFilters;
